/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DispenseSearch
 */
export interface DispenseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DispenseSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DispenseSearch
     */
    matiere?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof DispenseSearch
     */
    dateDemande?: DateSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof DispenseSearch
     */
    dateAcceptation?: DateSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DispenseSearch
     */
    typeDispense?: Int32ListSearch;
    /**
     * 
     * @type {number}
     * @memberof DispenseSearch
     */
    idinscription?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DispenseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DispenseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DispenseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DispenseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DispenseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DispenseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DispenseSearch interface.
 */
export function instanceOfDispenseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DispenseSearchFromJSON(json: any): DispenseSearch {
    return DispenseSearchFromJSONTyped(json, false);
}

export function DispenseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DispenseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'matiere': !exists(json, 'matiere') ? undefined : TextSearchFromJSON(json['matiere']),
        'dateDemande': !exists(json, 'dateDemande') ? undefined : DateSearchFromJSON(json['dateDemande']),
        'dateAcceptation': !exists(json, 'dateAcceptation') ? undefined : DateSearchFromJSON(json['dateAcceptation']),
        'typeDispense': !exists(json, 'typeDispense') ? undefined : Int32ListSearchFromJSON(json['typeDispense']),
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DispenseSearchToJSON(value?: DispenseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classe': TextSearchToJSON(value.classe),
        'matiere': TextSearchToJSON(value.matiere),
        'dateDemande': DateSearchToJSON(value.dateDemande),
        'dateAcceptation': DateSearchToJSON(value.dateAcceptation),
        'typeDispense': Int32ListSearchToJSON(value.typeDispense),
        'idinscription': value.idinscription,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

